/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_DagInputs */

const nl_planning_rooster_dag = /** @type {(inputs: Planning_Rooster_DagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dag`)
};

/**

* @param {Planning_Rooster_DagInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_dag = /** @type {((inputs?: Planning_Rooster_DagInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_DagInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_dag(inputs)
});
export { planning_rooster_dag as "planning.rooster.dag" }